var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getBadgesWithAnalyticsFunctionDef } from '../../../../backend/features/badges/shared';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import { useSearchParams } from 'react-router';
import useSWRInfinite from 'swr/infinite';
const badgesPerPage = 10;
export const badgeListFetchKey = 'badgeList';
export const useStorageBadgeList = () => {
    const [searchParams] = useSearchParams();
    const getBadgesWithAnalyticsPlatformFn = useTypedPlatformFunction(getBadgesWithAnalyticsFunctionDef);
    const getKey = (pageIndex) => {
        const limit = badgesPerPage;
        const offset = pageIndex * badgesPerPage;
        return [badgeListFetchKey, limit, offset];
    };
    const mapBadgeFilter = (filterData) => {
        let filter = [];
        if (filterData.search) {
            filter = [{ column: 'search', op: 'full-text-query', value: filterData.search }];
        }
        return filter;
    };
    const { data, setSize, isLoading, mutate } = useSWRInfinite(getKey, (_a) => __awaiter(void 0, [_a], void 0, function* ([, limit, offset]) {
        // INFO: internal filters used for e2e tests.
        const filterString = searchParams.get('filter');
        let filter = undefined;
        if (filterString) {
            try {
                const filterData = JSON.parse(filterString);
                filter = mapBadgeFilter(filterData);
            }
            catch (_b) {
                // ignore
            }
        }
        return getBadgesWithAnalyticsPlatformFn({ limit, offset, filter }).catch(handleErrorSnackbar);
    }), { revalidateOnFocus: false, revalidateOnReconnect: false });
    const fetchBadgeList = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    const rows = React.useMemo(() => (data === null || data === void 0 ? void 0 : data.flatMap((page) => (page === null || page === void 0 ? void 0 : page.rows) || [])) || [], [data]);
    const total = React.useMemo(() => { var _a; return ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.total) || 0; }, [data]);
    const loadMore = React.useCallback(() => {
        void setSize((prevSize) => prevSize + 1);
    }, [setSize]);
    return {
        isLoading,
        data: { rows, total },
        loadMore,
        fetchBadgeList,
    };
};
